import angular from 'angular';

import { } from './joint-diagram/joint-diagram.module.js';
import { QuickRepliesDetailsController } from './quick-replies.details.controller.js';
import { QuickRepliesNameEditionController } from './quick-replies.nameEdition.controller.js';
import { QuickRepliesService } from './quick-replies.service.js';
import { ClicksMetricHelperService } from './clicks-metric-helper.service';

angular
  .module('parameters.quick-replies', ['parameters.quick-replies.joint-diagram'])
  .controller('QuickRepliesDetailsController', QuickRepliesDetailsController)
  .controller('QuickRepliesNameEditionController', QuickRepliesNameEditionController)
  .factory('QuickRepliesFactory', QuickRepliesService.QuickRepliesFactory)
  .factory('ClicksMetricHelperFactory', ClicksMetricHelperService.ClicksMetricHelperFactory)
  ;
